import React, { useState } from "react";
import EventDetails from "../components/EventDetails";
import EventVenue from "../components/EventVenue";
import EventTicket from "../components/EventTicket";
import EventPayments from "../components/EventPayments";
import EventGuest from "../components/EventGuest";
import EventPublished from "../components/EventPublished";
import { ReactComponent as TickIcon } from "../../../assets/tick.svg";
import { Step, StepButton, StepIndicator, Stepper } from "@mui/joy";
import Seating from "../components/seating";
import { useLocation, useNavigate } from "react-router-dom";

const steps = ["Details", "Venue", "Seating", "Ticket", "Payments", "Guest"];
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
const AddEvents = () => {
  const query = useQuery();
  const id = query.get("id");
  const stepDone = query.get("step");
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [eventId, setEventId] = useState(id);

  const renderComponent = () => {
    switch (activeStep) {
      case 0:
        return (
          <EventDetails setActiveStep={setActiveStep} setEventId={setEventId} />
        );
      case 1:
        return <EventVenue setActiveStep={setActiveStep} eventId={eventId} />;
      case 2:
        return <Seating setActiveStep={setActiveStep} eventId={eventId} />;
      case 3:
        return <EventTicket setActiveStep={setActiveStep} eventId={eventId} />;
      case 4:
        return (
          <EventPayments setActiveStep={setActiveStep} eventId={eventId} />
        );
      case 5:
        return <EventGuest setActiveStep={setActiveStep} eventId={eventId} />;
      case 6:
        return <EventPublished setActiveStep={setActiveStep} />;
      default:
        return <EventDetails setActiveStep={setActiveStep} eventId={eventId} />;
    }
  };

  return (
    <>
      {activeStep !== 6 && (
        <div className="w-full bg-white py-4 px-8">
          <Stepper sx={{ width: "100%", "--StepIndicator-size": "28px" }}>
            {steps.map((step, index) => (
              <Step
                orientation={"vertical"}
                key={step}
                indicator={
                  <StepIndicator
                    variant={activeStep <= index ? "soft" : "solid"}
                    color={activeStep < index ? "neutral" : "primary"}
                    sx={{
                      backgroundImage:
                        activeStep < index
                          ? "transparent"
                          : "linear-gradient(180deg, #4DB1E1 0%, #2E3E8D 100%)",
                      bgcolor: activeStep < index ? "transparent" : "white",
                      border: activeStep < index ? "1px solid #A4A8B5" : "none",
                      color:
                        activeStep < index ? "rgba(0, 0, 0, 0.38)" : "white",
                      fontSize: "12px",
                    }}
                  >
                    {activeStep <= index ? "0" + (index + 1) : <TickIcon />}
                  </StepIndicator>
                }
                sx={{
                  "&::after": {
                    height: "3px !important",
                    backgroundSize: "20px 3px",
                    backgroundRepeat: "repeat-x",
                    backgroundColor: "transparent",
                    backgroundImage:
                      activeStep <= index
                        ? "linear-gradient(to right, #A4A8B5 40%, rgba(255, 255, 255, 0) 20%)"
                        : "linear-gradient(180deg, #4DB1E1 0%, #2E3E8D 100%)",
                  },
                }}
              >
                <StepButton onClick={() => setActiveStep(index)}>
                  {step}
                </StepButton>
              </Step>
            ))}
          </Stepper>
        </div>
      )}
      <div>{renderComponent()}</div>
    </>
  );
};

export default AddEvents;
